import React from "react";

const Exit = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M8.33325 16.332L9.74325 14.922L4.16325 9.33203L16.3333 9.33203V7.33203L4.16325 7.33203L9.74325 1.74203L8.33325 0.332031L0.333252 8.33203L8.33325 16.332Z"
        fill={color}
      />
    </svg>
  );
};

export default Exit;
